import { h, Fragment } from '@stencil/core';
import cn from 'classnames';
import { REPLATFORMED_COMPARATOR_URL, comparator, MAX_COMPARATOR_ITEMS, getComparisonSessionId, isV3, } from '@pes-ui/utils';
const COMPARATOR_URL = '/product-comparator';
const DESKTOP_WIDGET_HEIGHT = 56;
const MOBILE_WIDGET_HEIGHT = 48;
export class ComparisonBar {
  handleCompareQuantityChange(newQty, oldQty) {
    if (oldQty === 0) {
      return;
    }
    if (newQty > 0) {
      this.animateQuantityChange();
    }
  }
  handleDocumentUpdate() {
    if (this.isShown()) {
      const paddingBottom = this.isMobile ? MOBILE_WIDGET_HEIGHT : DESKTOP_WIDGET_HEIGHT;
      document.body.style.paddingBottom = `${paddingBottom}px`;
    }
    else {
      document.body.style.paddingBottom = '';
    }
  }
  handleComparatorProductsChange() {
    this.compareQuantity = comparator.getStoredProductIds().length;
  }
  constructor() {
    this.clearItems = () => {
      comparator.removeAll();
    };
    this.compareLabel = undefined;
    this.compareCta = undefined;
    this.clearListLabel = undefined;
    this.localeCode = undefined;
    this.isMobile = undefined;
    this.isPublic = false;
    this.isConfigured = false;
    this.compareQuantity = comparator.getStoredProductIds().length;
    this.compareLimit = MAX_COMPARATOR_ITEMS;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  animateQuantityChange() {
    if (this.comparisonBarEl) {
      const animationClassName = 'comparison-bar__container--is-animating';
      const removeAnimationHandler = () => {
        this.comparisonBarEl.classList.remove(animationClassName);
        this.comparisonBarEl.removeEventListener('animationend', removeAnimationHandler);
      };
      this.comparisonBarEl.classList.add(animationClassName);
      this.comparisonBarEl.addEventListener('animationend', removeAnimationHandler);
    }
  }
  comparisonUrl() {
    const url = `${this.localeCode}${isV3() && !this.isPublic ? REPLATFORMED_COMPARATOR_URL : COMPARATOR_URL}`;
    const productIds = comparator.getStoredProductIds().join('|');
    return `${url}/${getComparisonSessionId()}/${productIds}/`;
  }
  renderCompareQuantity() {
    return h("div", { class: "compare_qty" }, this.compareQuantity);
  }
  isShown() {
    return this.isConfigured && this.compareQuantity > 0;
  }
  renderDesktop() {
    return (h(Fragment, null, h("div", { class: "comparison__info" }, h("div", { class: "compare__info" }, h("div", { class: "compare__info-label" }, this.compareLabel), this.renderCompareQuantity()), h("button", { class: "compare__clear-btn", onClick: this.clearItems }, h("pes-icon", { class: "compare__clear-icon" }, "action_delete"), h("span", { class: "compare__clear-label" }, this.clearListLabel))), h("div", { class: "comparison__cta" }, h("qds-button", { importance: "standard", size: "standard", href: this.comparisonUrl(), text: this.compareCta }))));
  }
  renderMobile() {
    return (h(Fragment, null, h("a", { class: "comparison__link--mobile", href: this.comparisonUrl() }, this.compareLabel, " ", this.renderCompareQuantity()), h("button", { class: "compare__clear-label--mobile", onClick: this.clearItems }, h("pes-icon", null, "action_delete"))));
  }
  render() {
    return (h("div", { ref: (el) => (this.comparisonBarEl = el), class: cn('comparison-bar__container', this.isShown()
        ? 'comparison-bar__container--visible'
        : 'comparison-bar__container--hidden') }, h("div", { class: "comparison__bar" }, this.isMobile ? this.renderMobile() : this.renderDesktop())));
  }
  static get is() { return "pes-comparison-bar"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["comparison-bar.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["comparison-bar.css"]
    };
  }
  static get properties() {
    return {
      "compareLabel": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "compare-label",
        "reflect": false
      },
      "compareCta": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "compare-cta",
        "reflect": false
      },
      "clearListLabel": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "clear-list-label",
        "reflect": false
      },
      "localeCode": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "isMobile": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false
      },
      "isPublic": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-public",
        "reflect": false,
        "defaultValue": "false"
      },
      "isConfigured": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-configured",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "compareQuantity": {},
      "compareLimit": {}
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "compareQuantity",
        "methodName": "handleCompareQuantityChange"
      }, {
        "propName": "compareQuantity",
        "methodName": "handleDocumentUpdate"
      }, {
        "propName": "isMobile",
        "methodName": "handleDocumentUpdate"
      }, {
        "propName": "isConfigured",
        "methodName": "handleDocumentUpdate"
      }];
  }
  static get listeners() {
    return [{
        "name": "comparatorProductsChange",
        "method": "handleComparatorProductsChange",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
